// extracted by mini-css-extract-plugin
export default {"fr-view":"Zone_fr-view__57q-H","zone":"Zone_zone__NTEqT"};